import { useLocation } from 'react-router-dom';
import { TDailyReportPageLocationState } from '../../types/dailyReport';
import { formatDatetime } from '../../utils/common';

export const useHooks = () => {
  const getDateStr = (date: string | undefined): string | undefined => {
    if (!date) return undefined;
    return formatDatetime(new Date(date), 'YYYY-MM-DD');
  };

  // locationから必要な情報を取り出し
  const location = useLocation();
  const state = location.state as TDailyReportPageLocationState | undefined;

  const constructId = state?.constructId;

  const startDate = getDateStr(state?.startDate) ?? '';
  const endDate = getDateStr(state?.endDate) ?? '';

  return { constructId, startDate, endDate };
};
